



import IngredientsTable from "./IngredientsTable.vue";
import { Ingredient } from "@megarax/client/src/resources/plm/Ingredient";
import {
  createComponent,
  computed,
  createElement as h,
  ref,
  watch,
  reactive,
} from "@vue/composition-api";
import {
  komponentResource,
  Komponent,
} from "@megarax/client/src/resources/plm/Komponent";
import Decimal from "decimal.js";

interface IngredientsFormProps {
  value: Ingredient[];
}

export default createComponent<IngredientsFormProps>({
  components: {
    IngredientsTable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  setup(props, ctx) {
    const totalMassKg = computed<Decimal>(() =>
      props.value.reduce(
        (sum, skl) => (sum = skl.massKg.add(sum)),
        new Decimal(0),
      ),
    );

    watch(totalMassKg, (amount) => {
      ctx.emit("totalMassKgChange", amount);
    });

    return {
      totalMassKg,
      komponentResource,
    };
  },
});
